import { Box, Stack, Typography } from "@mui/material";
import { SmallModal } from "../../components/SmallModal";
import { useReference } from "../../hooks/useReferences";
import FormTimestamp from "../../molecules/FormTimestamp";
import UserTag from "../../components/UserTag";
import { TableTextWithEllipsis } from "../../molecules/TableTextWithEllipsis";

type ReferenceDetailModalProps = {
  open: boolean;
  onClose: () => void;
  referenceId: string;
};

export const ReferenceDetailModal = (props: ReferenceDetailModalProps) => {
  const { open, onClose, referenceId } = props;
  const { data: reference, isLoading } = useReference(referenceId);

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      title={isLoading ? undefined : `Reference - ${reference?.reference_num}`}
      isLoading={isLoading}
    >
      <Stack gap="10px">
        {reference?.title && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">Title</Typography>
            <Typography variant="body2">{reference?.title}</Typography>
          </Box>
        )}
        {reference?.reference_type && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">Type</Typography>
            <Typography variant="body2">{reference?.reference_type}</Typography>
          </Box>
        )}
        {reference?.year && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">Year</Typography>
            <Typography variant="body2">{reference?.year}</Typography>
          </Box>
        )}
        {reference?.author && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">Author</Typography>
            <UserTag name={reference?.author} />
          </Box>
        )}
        {reference?.data?.url && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">URL</Typography>
            <TableTextWithEllipsis
              value={reference?.data?.url}
              onClick={() => window.open(reference?.data?.url, "_blank")}
            />
          </Box>
        )}
        {reference?.data?.doi && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">DOI</Typography>
            <TableTextWithEllipsis
              value={reference?.data?.doi}
              onClick={() => window.open(reference?.data?.doi, "_blank")}
            />
          </Box>
        )}
        {reference?.data?.DOI && (
          <Box display="flex" flexDirection="column" gap="10px">
            <Typography variant="h3">DOI</Typography>
            <TableTextWithEllipsis
              value={reference?.data?.DOI}
              onClick={() => window.open(reference?.data?.DOI, "_blank")}
            />
          </Box>
        )}
        {reference && (
          <FormTimestamp
            padding="0px"
            direction="row"
            createdBy={reference?.created_by}
            updatedBy={reference?.updated_by}
            createdOn={reference?.created_on}
            updatedOn={reference?.updated_on}
          />
        )}
      </Stack>
    </SmallModal>
  );
};
